import React, { lazy, Suspense } from "react";

const ProfileEditor = lazy(() =>
  import("./ProfileEditor.jsx").then((module) => ({
    default: module.ProfileEditor,
  }))
);
const PrivateContactDetails = lazy(
  () => import("./PrivateContactDetails.jsx")
);
const TripInquiriesPanel = lazy(() => import("./TripInquiries.jsx"));
const AdminTravelerVerificationPanel = lazy(
  () => import("./AdminTravelerVerificationPanel.jsx")
);
const TravelerRoleRequestPanel = lazy(
  () => import("./TravelerRoleRequestPanel.jsx")
);

export default function ProfileSection({
  name,
  displayedProfile,
  viewedProfileId,
  configured,
  userId,
  role,
  profile,
  onProfileSaved,
  onBackToProfile,
  onTravelerVerificationUpdated,
  children,
}) {
  const editorProfile = profile || {
    id: userId,
    display_name: name && name !== "SabayBuy member" ? name : "",
    public_bio: "",
    public_barangay_code: null,
    is_public: false,
    inquiries_enabled: false,
    public_transaction_count_enabled: false,
  };

  return (
    <section className="user-profile" aria-labelledby="profile-heading">
      <h1 id="profile-heading">{name}</h1>
      <p>Role: {displayedProfile?.role || "Member"}</p>

      {displayedProfile?.role === "traveler" &&
        (displayedProfile.verified ? (
          <div className="traveler-review">
            <span>SabayBuy reviewed this traveler profile and account</span>
            <small>
              This is not identity or government-ID verification.
            </small>
          </div>
        ) : (
          <p>Traveler profile/account review: Not yet reviewed by SabayBuy.</p>
        ))}

      {!viewedProfileId && configured && userId && role !== "admin" && (
        <Suspense fallback={<p role="status">Loading profile settings…</p>}>
          <ProfileEditor
            profile={editorProfile}
            userId={userId}
            onSaved={onProfileSaved}
          />
        </Suspense>
      )}

      {!viewedProfileId && configured && userId && role !== "admin" && (
        <Suspense
          fallback={<p role="status">Loading private contact settings…</p>}
        >
          <PrivateContactDetails key={userId} userId={userId} />
        </Suspense>
      )}

      {!viewedProfileId && configured && userId && role !== "admin" && (
        <Suspense fallback={<p role="status">Loading trip inquiries…</p>}>
          <TripInquiriesPanel userId={userId} role={role} profile={profile} />
        </Suspense>
      )}

      {!viewedProfileId && role === "admin" && (
        <p className="review-muted">
          Administrator profiles cannot be published.
        </p>
      )}

      {!viewedProfileId && !configured && (
        <p className="review-muted">
          Connect Supabase to publish and manage a public profile.
        </p>
      )}

      {role === "admin" && !viewedProfileId && (
        <Suspense
          fallback={<p role="status">Loading traveler review tools…</p>}
        >
          <AdminTravelerVerificationPanel
            onUpdated={onTravelerVerificationUpdated}
          />
        </Suspense>
      )}

      {!viewedProfileId && configured && userId && role === "buyer" && (
        <Suspense fallback={<p role="status">Loading traveler request…</p>}>
          <TravelerRoleRequestPanel userId={userId} />
        </Suspense>
      )}

      {viewedProfileId && (
        <button
          type="button"
          className="secondary review-profile-link"
          onClick={onBackToProfile}
        >
          Back to my profile
        </button>
      )}
      {children}
    </section>
  );
}
